import React from 'react'
import image from "../images"
import { NavLink } from 'react-router-dom'
import "../css/adminStart.css"

function AdminStart() {
    return (
        <div class="start-div">
            <div class="bg_img startImg">
            </div>
            <div class="background-content">
                <img class="start-image" src={image.animals} alt="animals-profile" />
                <h1 class="petme">PETME</h1>
                <h2 class="admin">Admin</h2>
                <h3 class="adminMsg">Please Sign In to Continue.</h3>
                <NavLink className="admin-login-btn-link" to="/adminlogin">Log In</NavLink>
            </div>
        </div>
    )
}

export default AdminStart